import Blogbaner from '../../components/blogs/blogbaner';
import Blogspages from '../../components/blogs/blogspages';
import Head from 'next/head';
import Contactuscoman from '@/components/contactus/contactuscommon';
import { getGuestLogDetailsApi } from '@/components/action/easycampus';
import { useEffect } from 'react';

export default function Blogs() {


  useEffect(() => {
    handleGestLogUserData();
  }, []);

  const handleGestLogUserData = async () => {
    try {
      let data = {
        pageName:"Blog"
      }
      
      const res = await getGuestLogDetailsApi(data);
      return;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Head>
        <title>Online Campus Hiring Platform | Virtual Campus Drive Portal - EasyCampus</title>
        <meta property="og:type" content="website" />
        <meta name="description" content={"Enhance campus hiring and recruitment processes with EasyCampus automated campus recruitment software to conduct the pre-placement talks, various assessments, hold virtual interview."} />
        <meta property="og:title" content={"Enhance campus hiring and recruitment processes with EasyCampus automated campus recruitment software to conduct the pre-placement talks, various assessments, hold virtual interview."} />
        <meta name="description" content={"Enhance campus hiring and recruitment processes with EasyCampus automated campus recruitment software to conduct the pre-placement talks, various assessments, hold virtual interview."} />
        <meta name="keywords" content={"Easycampus"} />
        <meta property="og:url" content={"www.easycampus.in"} />
        <meta property="og:description" content={"BEnhance campus hiring and recruitment processes with EasyCampus automated campus recruitment software to conduct the pre-placement talks, various assessments, hold virtual interview."} />
        <meta property="og:image" content={'https://ec-images.s3.ap-south-1.amazonaws.com/easycampus-logo-for-video.png'} />
      </Head>
      <main className="flex min-h-screen flex-col">
        <div className="w-full mx-auto">
          <Contactuscoman />
          <Blogbaner />
          <Blogspages />
        </div>
      </main>
    </>
  );
}
